import * as LoginActions from './actions';

const initialState = {
  loginResult: null,
  correctUsername: null,
  blockTxHash: null,
  accountChanged: 0,
  accountChangedLower: 0,
  willCommit: false,
  committing: false,
  granting: false,
  isValid: false,
  isLower: false,
  validating: false,
  grantingLower: false,
  completed: false,
  progress: 0,
  savedStackId: null
}

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginActions.LOGIN_TRIED: {
      return {
        ...state,
        loginResult: action.loginResult
      }
    }
    case LoginActions.LOGIN_VALIDATE: {
      return {
        ...state,
        isValid: action.isValid,
        validating: action.validating
      }
    }
    case LoginActions.LOGIN_JUDGE: {
      return {
        ...state,
        isLower: action.isLower,
        validating: false
      }
    }
    case LoginActions.LOGIN_GRANTS: {
      return {
        ...state,
        grantingLower: true,
        grantLowerModalDisplayed: true,
        savedStackId: action.savedStackId
      }
    }
    case LoginActions.LOGIN_GRANTED: {
      return {
        ...state,
        grantingLower: false,
        savedStackId: action.savedStackId
      }
    }
    case LoginActions.SIGNUP_GRANTING: {
      return {
        ...state,
        granting: true,
        completed: false,
        progress: 1,
        savedStackId: action.savedStackId
      }
    }
    case LoginActions.BLOCK_RECEIVED: {
      return {
        ...state,
        blockTxHash: action.blockHeader.transactionsRoot
      }
    }
    case LoginActions.SIGNUP_GRANTED: {
      return {
        ...state,
        granting: false,
        progress: 2,
        savedStackId: null
      }
    }
    case LoginActions.SIGNUP_WILL_COMMIT: {
      return {
        ...state,
        willCommit: true,
      }
    }
    case LoginActions.SIGNUP_COMMITTING: {
      return {
        ...state,
        committing: true,
        completed: false,
        progress: 3,
        savedStackId: action.savedStackId
      }
    }
    case LoginActions.SIGNUP_COMMITTED: {
      return {
        ...state,
        accountChanged: 0,
        willCommit: false,
        committing: false,
        progress: 4,
        savedStackId: null
      }
    }
    case LoginActions.SIGNUP_COMMIT_COMPLETE: {
      return {
        ...state,
        completed: true
      }
    }
    case LoginActions.SIGNUP_CONFIGURATION_COMPLETE: {
      return {
        ...state,
        completed: false
      }
    }
    case LoginActions.ACCOUNTS_CHANGED: {
      return {
        ...state,
        accountChanged: 1
      }
    }
    case LoginActions.ACCOUNTS_RECOVERED: {
      return {
        ...state,
        accountChanged: 2
      }
    }
    case LoginActions.ACCOUNTS_CHANGED_LOWER: {
      return {
        ...state,
        accountChangedLower: 1,
        isValid: false,
        isLower: false
      }
    }
    case LoginActions.ACCOUNTS_RECOVERED_LOWER: {
      return {
        ...state,
        accountChangedLower: 2,
      }
    }
    case LoginActions.LOGIN_CHECK_USERNAME: {
      return {
        ...state,
        correctUsername: action.correctUsername,
        loginResult: action.correctUsername
      }
    }
    default: {
      return state;
    }
  }
}

export default loginReducer;
